import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "p-fluid p-m-5" }
const _hoisted_2 = { id: "noDataFound" }
const _hoisted_3 = { class: "table-header p-d-flex" }
const _hoisted_4 = { class: "p-input-icon-left p-mr-3 p-col-12" }
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: true,
    modal: true,
    class: "kn-dialog--toolbar--primary",
    header: _ctx.title,
    closable: false,
    style: _ctx.schedulationAgendaDescriptor.form.style
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--secondary",
        label: _ctx.$t('managers.schedulationAgendaManagement.detail.close'),
        onClick: _ctx.closeTemplate
      }, null, 8, ["label", "onClick"]),
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        label: _ctx.$t('managers.schedulationAgendaManagement.detail.select'),
        onClick: _ctx.handleSubmit
      }, null, 8, ["label", "onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode("form", _hoisted_1, [
        _createVNode(_component_DataTable, {
          id: "dataitem-datatable",
          value: _ctx.itemList,
          rows: 10,
          loading: _ctx.loading,
          class: "p-datatable-sm kn-table",
          dataKey: "id",
          filters: _ctx.filters,
          "onUpdate:filters": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filters = $event)),
          selection: _ctx.selectedItem,
          "onUpdate:selection": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedItem = $event)),
          globalFilterFields: _ctx.schedulationAgendaDescriptor.globalFilterFields,
          responsiveLayout: _ctx.schedulationAgendaDescriptor.responsiveLayout,
          breakpoint: _ctx.schedulationAgendaDescriptor.breakpoint,
          onRowClick: _ctx.selectRow,
          paginator: true,
          paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
          rowsPerPageOptions: [10, 15, 20],
          currentPageReportTemplate: _ctx.$t('common.table.footer.paginated', { first: '{first}', last: '{last}', totalRecords: '{totalRecords}' })
        }, _createSlots({
          empty: _withCtx(() => [
            _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('managers.schedulationAgendaManagement.info.noDataFound')), 1)
          ]),
          header: _withCtx(() => [
            _createVNode("div", _hoisted_3, [
              _createVNode("span", _hoisted_4, [
                _hoisted_5,
                _createVNode(_component_InputText, {
                  class: "kn-material-input",
                  modelValue: _ctx.filters['global'].value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters['global'].value = $event)),
                  type: "text",
                  placeholder: _ctx.$t('common.search'),
                  "data-test": "filterInput"
                }, null, 8, ["modelValue", "placeholder"])
              ])
            ])
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.schedulationAgendaDescriptor.columns, (col) => {
              return (_openBlock(), _createBlock(_component_Column, {
                class: "kn-truncated",
                style: col.style,
                field: col.field,
                header: _ctx.$t(col.header),
                sortable: false,
                key: col.field
              }, null, 8, ["style", "field", "header"]))
            }), 128))
          ]),
          _: 2
        }, [
          (_ctx.loading)
            ? {
                name: "loading",
                fn: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('managers.schedulationAgendaManagement.info.dataLoading')), 1)
                ])
              }
            : undefined
        ]), 1032, ["value", "loading", "filters", "selection", "globalFilterFields", "responsiveLayout", "breakpoint", "onRowClick", "currentPageReportTemplate"])
      ])
    ]),
    _: 1
  }, 8, ["header", "style"]))
}